<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div class="post-search-page mb-4">
    <b-card v-if="post">
      <router-link :to="{ name: 'post-search' }">
        &laquo; Back to post search
      </router-link>
    </b-card>

    <div class="row" v-if="!loading">
      <section class="col-12" v-if="post">
        <section class="d-flex flex-wrap mb-3">
          <h3 class="full-width font-weight-bolder">Postcard</h3>
          <post-card class="mx-auto" :post="post" />
        </section>

        <section v-if="post.post_type === 'Digital'">
          <h3 class="font-weight-bolder">Digital Replies</h3>

          <post-digital-reply :post="post"></post-digital-reply>
        </section>

      </section>
      <section v-else>
        <h4>No post found</h4>
      </section>
    </div>

    <section v-else>
      <b-spinner variant="primary" label="Loading post"></b-spinner>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import PostDigitalReply from '@/views/postView/sections/postDigitalReply/PostDigitalReply.vue';
  import PostCard from './sections/PostCard.vue';
  import PostService from '../../services/PostService';

  export default {
    name: 'PostView',
    components: {
      PostCard,
      PostDigitalReply,
    },
    props: {
      id: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        loading: true,
        loadingVisitor: true,
        loadingPrison: true,
        loadingMonitor: true,
        post: null,
        visitor: null,
      };
    },
    computed: {
      ...mapState({}),
    },
    mounted() {
      this.getPost();
    },
    methods: {
      getPost() {
        this.loading = true;
        PostService.getPost(this.id).then(res => {
          this.post = res.data;
          // this.getVisitorDetails();
        }).catch(err => {
          console.log('could not get post', err);
          this.$toast.error('Could not get post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
      // getVisitorDetails() {
      //   this.loadingVisitor = true;
      //   VisitorUsersService.getUser(this.post.user_id).then(res => {
      //     this.visitor = res.data;
      //   }).catch(err => {
      //     console.log('could not get sender details', err);
      //     this.$toast.error('Could not get sender details, please refresh and try again', {
      //       toastClassName: ['toast-std', 'warning-toast'],
      //     });
      //   }).finally(() => {
      //     this.loadingVisitor = false;
      //   });
      // },
    },
  };
</script>
